import { createSlice } from '@reduxjs/toolkit';
import { fetchSetupChecklist, dismissChecklistItem, restoreChecklistItem, remindLaterChecklist } from '../thunks/setupChecklistThunks';

const initialState = {
  overallComplete: false,
  completedCount: 0,
  totalCount: 0,
  items: [],
  dismissedKeys: [],
  loading: false,
  initialized: false,
  error: null,
  remindLaterUntil: null,
};

const setupChecklistSlice = createSlice({
  name: 'setupChecklist',
  initialState,
  reducers: {
    clearSetupChecklist: () => ({ ...initialState }),
    invalidateSetupChecklist: (state) => {
      state.initialized = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSetupChecklist.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSetupChecklist.fulfilled, (state, action) => {
        state.loading = false;
        state.initialized = true;

        // Original code:
        // state.overallComplete = action.payload.overallComplete;
        // state.completedCount = action.payload.completedCount;
        // state.totalCount = action.payload.totalCount;
        // state.items = action.payload.items || [];
        // state.dismissedKeys = action.payload.dismissedKeys || [];
        // state.remindLaterUntil = action.payload.remindLaterUntil || null;

        // Filter out GOOGLE_MEET
        const rawItems = action.payload?.items || [];
        const filteredItems = rawItems.filter((item) => item.key !== 'GOOGLE_MEET');
        const completed = filteredItems.filter((item) => item.complete).length;
        const total = filteredItems.length;

        state.items = filteredItems;
        state.completedCount = completed;
        state.totalCount = total;
        state.overallComplete = total > 0 && completed === total;
        state.dismissedKeys = (action.payload?.dismissedKeys || []).filter((k) => k !== 'GOOGLE_MEET');
        state.remindLaterUntil = action.payload?.remindLaterUntil || null;
      })
      .addCase(fetchSetupChecklist.rejected, (state, action) => {
        state.loading = false;
        state.initialized = true;
        state.error = action.payload || 'Failed to fetch setup checklist';
      })
      // Dismiss
      .addCase(dismissChecklistItem.fulfilled, (state, action) => {
        const key = action.payload;
        if (!state.dismissedKeys.includes(key)) {
          state.dismissedKeys.push(key);
        }
        // Remove from visible items
        // state.items = state.items.filter((item) => item.key !== key);
        state.items = state.items.filter((item) => item.key !== key && item.key !== 'GOOGLE_MEET');
        state.totalCount = state.items.length;
        state.completedCount = state.items.filter((item) => item.complete).length;
        state.overallComplete = state.totalCount > 0 && state.completedCount === state.totalCount;
      })
      // Restore
      .addCase(restoreChecklistItem.fulfilled, (state) => {
        // Re-fetch will update the state properly
        state.initialized = false;
      });
  },
});

export const { clearSetupChecklist, invalidateSetupChecklist } =
  setupChecklistSlice.actions;
export default setupChecklistSlice.reducer;
